/**
 * @generated SignedSource<<6ef143bc33a89522ecf59d3599266ce8>>
 * @relayHash 2d0840f67bfea9883f354f40bf5cc4bb
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2d0840f67bfea9883f354f40bf5cc4bb

import { ConcreteRequest } from 'relay-runtime';
export type dePatientByPatientIdQuery$variables = {
  patientId: string;
};
export type dePatientByPatientIdQuery$data = {
  readonly patientByPatientId: {
    readonly id: string;
  } | null;
};
export type dePatientByPatientIdQuery = {
  response: dePatientByPatientIdQuery$data;
  variables: dePatientByPatientIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "patientId"
  }
],
v1 = [
  {
    "alias": "patientByPatientId",
    "args": [
      {
        "kind": "Variable",
        "name": "patientId",
        "variableName": "patientId"
      }
    ],
    "concreteType": "de_Patient",
    "kind": "LinkedField",
    "name": "de_patientByPatientId",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "dePatientByPatientIdQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "dePatientByPatientIdQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "2d0840f67bfea9883f354f40bf5cc4bb",
    "metadata": {},
    "name": "dePatientByPatientIdQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "4b6933e84c79fd5c32413d4e8f372edc";

export default node;
